var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPrimeHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "140px",
    height: "35.94px",
    viewBox: "0 0 140 35.94",
    enableBackground: "new 0 0 140 35.94",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 31.063,
    fill: "#FFFFFF",
    width: 137,
    height: 3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 15.435,
    cy: 32.683,
    r: 3.257
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 26.464,
    cy: 32.683,
    r: 3.257
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 48.519,
    cy: 32.683,
    r: 3.257
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 70.575,
    cy: 32.683,
    r: 3.256
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 114.689,
    cy: 32.683,
    r: 3.257
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 136.744,
    cy: 32.683,
    r: 3.256
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.313,14.764h-5.635v9.115h-2.585V0.677h8.685c4.209,0,7.392,2.221,7.392,6.928 C33.169,12.212,29.955,14.764,25.313,14.764z M25.679,3.03h-6v9.381h5.668c3.546,0,5.237-1.624,5.237-4.707 C30.584,4.72,28.861,3.03,25.679,3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M53.486,13.803l5.105,10.077h-2.983l-4.972-9.877h-5.502v9.877h-2.585V0.677h9.182 c4.078,0,7.226,2.088,7.226,6.563C58.955,10.853,56.801,13.106,53.486,13.803z M51.63,3.03h-6.497v8.651h6.166 c3.447,0,5.072-1.425,5.072-4.342C56.37,4.488,54.712,3.03,51.63,3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M69.228,23.879V0.677h2.586v23.203H69.228z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M100.583,23.879V8.168V5.682c-0.231,0.895-0.895,2.619-1.392,3.845l-6.198,14.949L86.894,9.527 c-0.498-1.193-1.127-2.95-1.359-3.845v2.486v15.711h-2.486V0.677h2.884l5.469,13.889c0.563,1.392,1.393,3.546,1.658,4.508 c0.298-0.995,1.127-3.149,1.657-4.508l5.535-13.889h2.818v23.203H100.583z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M114.137,23.879V0.677h14.021V3.03h-11.436v7.292h6.629v2.354h-6.629v8.85h11.933v2.354H114.137z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 70.602,
    cy: 3.211,
    r: 3.211
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrimeHorizontal);
export default __webpack_public_path__ + "static/media/logo-prime-horizontal.09abde8c3586d05c3f631fb038d7ff15.svg";
export { ForwardRef as ReactComponent };